import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useApplicationModal } from '../context/ApplicationModalContext';

/**
 * Preserves backward compatibility with legacy /muraciet URLs (older marketing links,
 * shares, WhatsApp messages). On mount we open the application modal (honoring any
 * ?amount= parameter) and redirect to the homepage.
 */
export const ApplicationRedirect = () => {
  const [params] = useSearchParams();
  const { openModal } = useApplicationModal();
  const navigate = useNavigate();

  useEffect(() => {
    const amount = params.get('amount') || '';
    openModal({ amount });
    navigate('/', { replace: true });
  }, []);

  return null;
};
